import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import UserContextProvider from "./contexts/userContext";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<UserContextProvider><App /></UserContextProvider>);
